/**
 * London Smoke & Cure — shared Njord Cloud Run HTTP client.
 */

import { getNjordCloudRunUrl, njordAdminHeaders } from './njordConfig';
import { njordFetchErrorMessage } from './njordHttpErrors';
import { isNjordApiReady } from './njordReadiness';

/**
 * @param {Response} res
 */
export async function parseNjordJson(res) {
    const text = await res.text();
    let data;
    try {
        data = text ? JSON.parse(text) : {};
    } catch {
        throw new Error(`Njord API non-JSON (${res.status}): ${text.slice(0, 200)}`);
    }
    if (!res.ok) {
        throw new Error(data.error || data.message || `HTTP ${res.status}`);
    }
    return data;
}

/**
 * @param {string} path
 * @param {RequestInit} [init]
 */
export async function njordApiFetch(path, init = {}) {
    const base = getNjordCloudRunUrl();
    if (!base) throw new Error('REACT_APP_NJORD_CLOUD_RUN_URL is not set');
    const url = `${base}${path.startsWith('/') ? path : `/${path}`}`;
    const headers = { ...njordAdminHeaders(), ...(init.headers || {}) };
    try {
        const res = await fetch(url, { ...init, headers, cache: 'no-store' });
        return parseNjordJson(res);
    } catch (err) {
        throw new Error(njordFetchErrorMessage(err));
    }
}

/**
 * @param {string} path
 * @param {RequestInit} [init]
 */
export async function njordApiFetchText(path, init = {}) {
    const base = getNjordCloudRunUrl();
    if (!base) throw new Error('REACT_APP_NJORD_CLOUD_RUN_URL is not set');
    const url = `${base}${path.startsWith('/') ? path : `/${path}`}`;
    const headers = { ...njordAdminHeaders(), ...(init.headers || {}) };
    const res = await fetch(url, { ...init, headers, cache: 'no-store' });
    const text = await res.text();
    if (!res.ok) {
        let msg = text.slice(0, 200);
        try {
            const j = JSON.parse(text);
            msg = j.error || msg;
        } catch {
            /* plain text */
        }
        throw new Error(msg || `HTTP ${res.status}`);
    }
    return text;
}

/** @returns {boolean} */
export function njordApiAvailable() {
    return isNjordApiReady();
}

/**
 * Token-gated public share routes (no admin key). Share token is the secret.
 * @param {string} path
 * @param {RequestInit} [init]
 */
export async function njordPublicFetch(path, init = {}) {
    const base = getNjordCloudRunUrl();
    if (!base) throw new Error('REACT_APP_NJORD_CLOUD_RUN_URL is not set');
    const url = `${base}${path.startsWith('/') ? path : `/${path}`}`;
    const res = await fetch(url, { ...init, headers: { Accept: 'application/json', ...(init.headers || {}) }, cache: 'no-store' });
    return parseNjordJson(res);
}
